import { Box } from "@mui/material";
import { FC } from "react";
import { TabPanelProps } from "../../../portal/src/app/interfaceTypes";

export const TabPanel: FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) =>
  value !== index ? null : (
    <Box
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box>{children}</Box>
    </Box>
  );
